import { Pipe, PipeTransform } from '@angular/core';
import { DropdownModelString } from '@shared/models/dropdown-string-model';

@Pipe({
    name: 'filterLocale'
})
export class LocalePipe implements PipeTransform {
    transform(itemsLocalisation: DropdownModelString[], language: string): DropdownModelString[] {
        return itemsLocalisation?.filter(x => x.id?.substring(0, 2) === language);
    }
}
